module.exports = __webpack_public_path__ + "img/Akute_Gefahr_durch_Radioaktivität.95835a0d.svg";